/* 🤖 this file was generated by svg-to-ts */
export const DfIconBadge16: {
  name: 'badge-16';
  data: string;
} = {
  name: 'badge-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0h8a2 2 0 0 1 2 2v9.481a1 1 0 0 1-.424.818l-5 3.523a1 1 0 0 1-1.152 0l-5-3.523A1 1 0 0 1 2 11.48V2a2 2 0 0 1 2-2zm3.79 9.306a.431.431 0 0 1 .42 0l1.151.64a.435.435 0 0 0 .637-.451l-.23-1.42a.437.437 0 0 1 .117-.374l.992-1.022a.436.436 0 0 0-.245-.735L9.3 5.74a.433.433 0 0 1-.326-.246l-.58-1.243a.432.432 0 0 0-.784 0l-.582 1.243a.433.433 0 0 1-.326.246l-1.333.204a.437.437 0 0 0-.245.735l.991 1.022c.097.099.14.238.118.374l-.23 1.42a.432.432 0 0 0 .637.451z" fill-rule="evenodd"/></svg>`
};
